/*
 * Step 3 demos of the MOGRT setup steps (sections/mogrt-steps.liquid): the
 * template's own controls being set in Essential Graphics, the result
 * playing in the Program monitor beside them. This runs them; each kind
 * registers itself from assets/mogrt-demo-<kind>.js:
 *
 *   window.MogrtDemos = window.MogrtDemos || {};
 *   window.MogrtDemos.text = {
 *     rest(screen) {},              // the finished frame (also before it runs)
 *     async pass(screen, t) {},     // one loop; await t.* between steps
 *   };
 *
 * t.wait(ms) resolves false once the loop should stop (scrolled away), so a
 * pass returns as soon as one comes back false. t.type(el, text) types into
 * a panel field one letter at a time, t.live(on) sets or clears [data-live]
 * on the screen (the panel's controls glide to their second values).
 * Each screen loops while it's in view; with reduced motion it shows rest().
 */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  const tools = (screen, run) => {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)).then(() => run.alive);
    return {
      wait,
      alive: () => run.alive,
      live(on) {
        screen.toggleAttribute('data-live', !!on);
      },
      async type(el, text, { speed = 70, clear = true } = {}) {
        if (!el) return run.alive;
        el.classList.add('is-typing');
        if (clear) el.textContent = '';
        for (const ch of String(text)) {
          if (!(await wait(speed + (/\s/.test(ch) ? speed * 0.6 : 0)))) break;
          el.textContent += ch;
        }
        const ok = await wait(260);
        el.classList.remove('is-typing');
        return ok;
      },
    };
  };

  const init = (screen) => {
    if (screen.hasAttribute('data-ms-ready')) return;
    const demo = (window.MogrtDemos || {})[screen.dataset.msDemo];
    if (!demo) return;
    screen.setAttribute('data-ms-ready', '');
    let run = { alive: false };

    const rest = () => {
      run.alive = false;
      screen.removeAttribute('data-live');
      demo.rest(screen);
    };
    const start = async () => {
      run.alive = false;
      if (still.matches) return rest();
      const mine = (run = { alive: true });
      const t = tools(screen, mine);
      while (mine.alive) {
        screen.removeAttribute('data-live');
        if ((await demo.pass(screen, t)) === false || !mine.alive) break;
      }
    };

    rest();
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : rest()), { threshold: 0.45 }).observe(screen);
  };

  const arm = (root) => root.querySelectorAll('[data-ms-demo]').forEach(init);
  // the kinds' scripts load after this one (both deferred), so wait for them;
  // arming twice is harmless
  const go = () => arm(document);
  document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', go);
  if (document.readyState === 'complete') setTimeout(go);
  document.addEventListener('shopify:section:load', (event) => setTimeout(() => arm(event.target)));
})();
